import React from 'react';

class banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      charityName: this.props.charityName,
      pageName: this.props.pageName
    };
  }
  render() {
    return (
      <div>
        <div className="bannerContainer">
          <div className="centerWrap">
            <h1>{this.state.charityName}</h1>
          </div>
        </div>
        <div className="navigation">
          <ul className="centerWrap">
            <li>
              <a href="/givingfund/partner/profile" id="p_profile" className={(this.state.pageName=='profile') ? 'active' : ''}>PROFILE</a>
            </li>
            <li>
              <a href="/givingfund/partner/dashboard" id="p_dashboard" className={(this.state.pageName=='dashboard') ? 'active' : ''}>DASHBOARD</a>
            </li>
            <li>
              <a href="/givingfund/partner/activity" id="p_activity" className={(this.state.pageName=='activity') ? 'active' : ''}>ACTIVITY</a>
            </li>
            <li>
              <a href="/givingfund/partner/recentdonations" id="p_recentdonate" className={(this.state.pageName=='recentdonations') ? 'active' : ''}>RECENT DONATIONS</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
export default banner;



// WEBPACK FOOTER //
// ./partner/components/banner.js